import React, { useState } from 'react';
import { Row, Col, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __ConsolidationLeters, __MessageTypes, __Deactivate, __AppElementType } from '../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetBoarScope } from '../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../common/ObjectStructures/Trasnversal';
import MessageBox from '../../../components/Common/Message/MessageBox';
import PropTypes from 'prop-types';
import CTextBox from '../../../components/Common/CTextBox';
import Picker from '../../../components/Common/Picker';

import { isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';
import { Dropdown } from '@fluentui/react';
import { __Consolidation } from '../../../common/Dictionaries';
import { __ComponentTypes } from '../../../common/Dictionaries';
import { useDispatch, useSelector } from 'react-redux';
import { action_setBoardConfigAppElementList, action_setBoardConfigElementList, action_setBoardConfigTemplateProperty } from '../../../reducers/actions/KPI/actions';
import { useGetAppElementsForBoardConfig, useGetElementsForBoardConfig } from './useOfBoardConfig';
import CLabel from '../../../components/Common/CLabel';
import CValidator from '../../../components/Common/CValidator';

const SidePanelConfigure = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { _templateConfig: templateConfig } = useSelector((state) => state.configBoardScope);
    const { _appElementTypeList: appElementTypeList } = useSelector((state) => state.configBoardScope);
    const { _elementList: elementList } = useSelector((state) => state.configBoardScope);
    
    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
    } = props;

    const [titleStructureCards, setTitleStructureCards] = useState([{title: "", index: 1}]);
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const isReportType = window.location.href.toLocaleLowerCase().indexOf('configuration/report') !== -1;

    useGetAppElementsForBoardConfig(appElementTypeList, t('data-lang-lbl-select'));
    useGetElementsForBoardConfig(elementList, templateConfig.appElementSelected, t('data-lang-lbl-select'))

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [isValidForm, setIsValidForm] = useState({
        title : true,
        appElementType : true,
        elementType : true,
    });
    
    const validateForm = () => {
        let isValid = true;

        isValidForm.title = !isNullUndefinedOrEmpty(templateConfig.title);

        if (!isReportType) {
            isValidForm.appElementType = templateConfig.appElementSelected !== null ? (templateConfig.appElementSelected.key !== 0) : false;
            isValidForm.elementType = templateConfig.elementSelected !== null ? (templateConfig.elementSelected.id !== 0) : false;
        }

        isValid = isValidForm.title && (isReportType ? true : isValidForm.appElementType && isValidForm.elementType);

        setIsValidForm(isValidForm)

        return isValid
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)
        setIsValidForm({
            title : true,
            appElementType : true,
            elementType : true,
        })
    };

    const onChangeElement = (currentNode, selectedNodes) => {
        elementList.forEach(x => {
            x.checked = false;
            if (x.id === currentNode.id) {
                x.checked = selectedNodes.length > 0 ? currentNode.checked : false;
            }
        })
        
        setIsValidForm(prevState => ({
            ...prevState,
            elementType: selectedNodes.length > 0
        }));

        dispatch(action_setBoardConfigElementList(elementList));
        dispatch(action_setBoardConfigTemplateProperty("elementSelected", selectedNodes.length > 0 ? currentNode : null))
    };

    const onChangeAppElementType = (currentControl, selectedNode) => {
        appElementTypeList.forEach(x => {
            x.checked = false;
            if (x.key === selectedNode.key) {
                x.checked = selectedNode.checked;
            }
        });

        setIsValidForm(prevState => ({
            ...prevState,
            appElementType: selectedNode.key === 0 ? false : true
        }));

        dispatch(action_setBoardConfigAppElementList(appElementTypeList));
        dispatch(action_setBoardConfigTemplateProperty("appElementSelected", selectedNode))
        dispatch(action_setBoardConfigElementList(null));
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const setterObjStructureTitle = (controlValue) => {
        
        if (!isNullUndefinedOrEmpty(controlValue)) {
            setIsValidForm(prevState => ({
                ...prevState,
                title: true
            }));
        }
        else {
            setIsValidForm(prevState => ({
                ...prevState,
                title: false
            }));
        }

        dispatch(action_setBoardConfigTemplateProperty("title", controlValue))
    }

    const setterObjReportStructureTitle = (controlValue, controlIndex) => {
        
        if (!isNullUndefinedOrEmpty(controlValue)) {
            setIsValidForm(prevState => ({
                ...prevState,
                title: true
            }));
        }
        else {
            setIsValidForm(prevState => ({
                ...prevState,
                title: false
            }));
        }

        titleStructureCards.find(x =>x.index === controlIndex).title = controlValue;
        setTitleStructureCards(titleStructureCards)
    }

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onSaveConfiguration = () => {
        if (validateForm()) {
            dispatch(action_setBoardConfigTemplateProperty("title", templateConfig.title))
            dispatch(action_setBoardConfigTemplateProperty("elementSelected", templateConfig.elementSelected))
            dispatch(action_setBoardConfigTemplateProperty("appElementSelected", templateConfig.appElementSelected))

            onDismissPanel();
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    }

    const onAddStructure = () => {
        let auxTitleStructureCards = [...titleStructureCards]
        auxTitleStructureCards.push({ title: "", index: titleStructureCards.length + 1 });
        setTitleStructureCards(auxTitleStructureCards)
    }

    const onRemoveStructure = (index) => {
        let auxTitleStructureCards = [...titleStructureCards]
        auxTitleStructureCards = auxTitleStructureCards.filter(x => x.index !== index);

        auxTitleStructureCards.map((item, index) => (
            item.index = index + 1
        ));

        setTitleStructureCards(auxTitleStructureCards)
    }

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={ onSaveConfiguration } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                        {
                            isReportType &&
                            <PrimaryButton onClick={ onAddStructure } styles={_global_buttonStyles}>{ t('data-lang-btn-addslide') }</PrimaryButton>
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-cancel') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ 
                    isReportType ?
                        t('data-lang-boxname-configurereport') :
                        t('data-lang-boxname-configureboard')
                }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    isReportType && titleStructureCards.map((item, index) => 
                        <Row key={index} className="pt-5">
                            <Col>
                                <Card>
                                    <IconButton iconProps={{iconName: "Cancel"}} onClick={() => onRemoveStructure(item.index)} />
                                    <CTextBox
                                        labelText={t('data-lang-lbl-title2')}
                                        textBoxName={item.index}
                                        controlValue={item.title}
                                        setterControlValue={setterObjReportStructureTitle}
                                        isInValid={!item.title}
                                    />
                                </Card>
                            </Col>
                        </Row>
                    )
                    
                }
                
                {
                    !isReportType &&
                    <>
                        <Row className="pt-5">
                            <Col>
                                <CTextBox
                                    labelText={t('data-lang-lbl-title2')}
                                    controlValue={templateConfig.title}
                                    setterControlValue={setterObjStructureTitle}
                                    isInValid={!isValidForm.title}
                                />
                            </Col>
                        </Row>
                        <Row className="pt-5">
                            <Col>
                                <CLabel labelText={t('data-lang-lbl-elementtype')} className="fontSizeNormal pb-2" />
                                {
                                    appElementTypeList &&
                                    <Dropdown
                                        className="appElementTypeDropdown"
                                        placeholder={t('data-lang-placeholder-selectoption')}
                                        options={ appElementTypeList ? appElementTypeList : [] }
                                        selectedKey={templateConfig.appElementSelected ? templateConfig.appElementSelected.key : undefined}
                                        onChange={ onChangeAppElementType }
                                        errorMessage={!isValidForm.appElementType ? t('data-lang-msg-required') : undefined}
                                        required={true}
                                    />
                                }
                            </Col>
                        </Row>
                        <Row className="pt-5">
                            <Col>
                                <Picker
                                    data={ elementList !== null ? elementList : [] }
                                    mode="simpleSelect"
                                    className="dropdown-checkbox"
                                    isInValid={!isValidForm.elementType}                                    
                                    texts={{ placeholder: t('data-lang-placeholder-selectoption') }}
                                    onChange={ onChangeElement }
                                    labelText={ t('data-lang-lbl-element') }
                                    refresh={true}
                                    disabled={templateConfig.appElementSelected === null || templateConfig.appElementSelected.key === 0}
                                />
                                <CValidator isInValid={!isValidForm.elementType} />
                            </Col>
                        </Row>
                    </>
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelConfigure.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default SidePanelConfigure;